import "./eBooks.css";
import masteringReact from "../../assets/images/mastering-react.jpg";
import javascriptEssentials from "../../assets/images/javaScript-essentials.jpg";
import cssMastery from "../../assets/images/css-mastery.jpg";
import fullstackDeveloperGuide from "../../assets/images/fullstack-developer-guide.jpg";
import nodejsInDepth from "../../assets/images/node.js-in-depth.jpg";
import UIUXForDevelopers from "../../assets/images/UIUX-for-developers.jpg";
import { useEffect } from "react";
import { Helmet } from "react-helmet";


export default function Ebooks() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>

      <Helmet>
        <title>SHOP.CO | eBooks - Download & Learn</title>
        <meta
          name="description"
          content="Browse SHOP.CO’s collection of eBooks. Download helpful resources and guides designed to enhance your shopping and learning experience."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/resources/ebooks/"
        />
      </Helmet>
      <div className="ebooks-container">
        <h1 className="ebooks-title">Free eBooks</h1>
        <p className="ebooks-description">
          Explore our collection of free eBooks for developers and tech enthusiasts. Whether you're a beginner or an experienced coder, you'll find something useful here.
        </p>

        <div className="ebooks-grid">
          <div className="ebook-card">
            <img src={masteringReact} alt="Mastering React" />
            <h3>Mastering React</h3>
            <p>Learn React from scratch with this complete beginner-to-pro guide. Covers Hooks, Redux, and modern patterns.</p>
            <a href="#" className="ebook-btn" download>Download</a>
          </div>

          <div className="ebook-card">
            <img src={javascriptEssentials} alt="JavaScript Essentials" />
            <h3>JavaScript Essentials</h3>
            <p>Understand the fundamentals of JavaScript and become confident in the language powering the web.</p>
            <a href="#" className="ebook-btn" download>Download</a>
          </div>

          <div className="ebook-card">
            <img src={cssMastery} alt="CSS Mastery" />
            <h3>CSS Mastery</h3>
            <p>Deep dive into CSS layouts, animations, and advanced styling techniques. Perfect for frontend developers.</p>
            <a href="#" className="ebook-btn" download>Download</a>
          </div>

          <div className="ebook-card">
            <img src={fullstackDeveloperGuide} alt="Fullstack Developer Guide" />
            <h3>Fullstack Developer Guide</h3>
            <p>From frontend to backend, this guide helps you build complete fullstack applications using modern tech stacks.</p>
            <a href="#" className="ebook-btn" download>Download</a>
          </div>

          <div className="ebook-card">
            <img src={nodejsInDepth} alt="Node.js in Depth" />
            <h3>Node.js in Depth</h3>
            <p>Build scalable backend systems with Node.js. Covers Express, APIs, authentication, and performance tips.</p>
            <a href="#" className="ebook-btn" download>Download</a>
          </div>

          <div className="ebook-card">
            <img src={UIUXForDevelopers} alt="UI/UX for Developers" />
            <h3>UI/UX for Developers</h3>
            <p>Design better interfaces with UI/UX best practices tailored for developers. Includes real-world examples.</p>
            <a href="#" className="ebook-btn" download>Download</a>
          </div>
        </div>
      </div>
    </>
  );
}
